import React, {useState} from 'react';
import { List, Icon, IconProps, SemanticCOLORS } from 'semantic-ui-react';

type Props = {
  fileName: string;
};

const getFileExtension = (fileName: string) => {
  const parts = fileName.split('.');
  if (parts.length > 1) {
    return parts.pop()!.toLowerCase();
  }
  return '';
};

const getFileTypeIcon = (fileName: string): { iconName: any; color: SemanticCOLORS } => {
  const fileExtension = getFileExtension(fileName);

  switch (fileExtension) {
    case 'pdf':
      return { iconName: 'file pdf outline', color: 'red' };
    case 'doc':
    case 'docx':
      return { iconName: 'file word outline', color: 'blue' };
    case 'ppt':
    case 'pptx':
      return { iconName: 'file powerpoint outline', color: 'orange' };
    case 'xls':
    case 'xlsx':
      return { iconName: 'file excel outline', color: 'green' };
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return { iconName: 'file image outline', color: 'teal' };
    case 'mp3':
    case 'wav':
      return { iconName: 'file audio outline', color: 'purple' };
    case 'mp4':
    case 'mov':
      return { iconName: 'file video outline', color: 'pink' };
    case 'zip':
    case 'rar':
      return { iconName: 'file archive outline', color: 'brown' };
    default:
      return { iconName: 'file outline', color: 'grey' };
  }
};

const FileIcon: React.FC<Props & IconProps> = ({ fileName, ...rest }) => {
  const { iconName, color } = getFileTypeIcon(fileName);
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const iconColor = hovered ? color : 'grey';

  return (
    <Icon
      name={iconName}
      color={iconColor}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...rest}
    />
  );
};

export default FileIcon;
